var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPadlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 84,
    viewBox: "0 0 66 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 39C0 34.0295 4.02947 30 9 30H57C61.9707 30 66 34.0295 66 39V75C66 79.9707 61.9707 84 57 84H9C4.0295 84 0 79.9707 0 75V39ZM9 36C7.34317 36 6 37.3432 6 39V75C6 76.6569 7.34313 78 9 78H57C58.6569 78 60 76.6569 60 75V39C60 37.3431 58.6569 36 57 36H9Z",
    fill: "#CAC4D0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0295 7.02944C20.5303 2.52855 26.6348 0 33 0C39.3652 0 45.4696 2.52852 49.9704 7.02936C49.9705 7.0294 49.9705 7.02944 49.9706 7.02948M16.0295 7.02944C16.0295 7.02946 16.0295 7.02947 16.0294 7.02948C11.5286 11.5303 9 17.6348 9 24V33C9 34.6569 10.3431 36 12 36C13.6569 36 15 34.6569 15 33V24C15 19.2261 16.8964 14.6477 20.2721 11.2721L20.2721 11.2721C23.6477 7.89643 28.2261 6 33 6C37.7739 6 42.3523 7.89643 45.7279 11.2721L45.728 11.2722C49.1038 14.6477 51 19.226 51 24V33C51 34.6569 52.3431 36 54 36C55.6569 36 57 34.6569 57 33V24C57 17.6349 54.4718 11.5304 49.9706 7.02948",
    fill: "#CAC4D0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 57C27 53.6863 29.6863 51 33 51C36.3137 51 39 53.6863 39 57C39 60.3137 36.3137 63 33 63C29.6863 63 27 60.3137 27 57Z",
    fill: "#CAC4D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPadlock);
export default __webpack_public_path__ + "static/media/padlock.6f53e1711c873c7a9e21242a8eb98963.svg";
export { ForwardRef as ReactComponent };